(() => {
  function init(root) {
    root.querySelectorAll('.lh-expand').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const item = button.closest('.lh-item');
      const desktop = button.closest('.lh-menu--desktop');
      const set = open => { button.setAttribute('aria-expanded', String(open)); panel.hidden = !open; };
      const closeOthers = () => button.closest('.lh-menu').querySelectorAll('.lh-expand').forEach(other => {
        if (other !== button) { other.setAttribute('aria-expanded','false'); document.getElementById(other.getAttribute('aria-controls')).hidden = true; }
      });
      button.addEventListener('click', () => { const open = button.getAttribute('aria-expanded') !== 'true'; closeOthers(); set(open); });
      if (desktop) {
        item.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { closeOthers(); set(true); } });
        item.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && !item.contains(document.activeElement)) set(false); });
        item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) set(false); });
      }
      item.addEventListener('keydown', e => { if (e.key === 'Escape') { set(false); button.focus(); } });
      document.addEventListener('click', e => { if (desktop && !item.contains(e.target)) set(false); });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  const header = document.querySelector('.lh-header');
  if (!header) return;
  const update = () => header.classList.toggle('lh-scrolled', window.scrollY > 190);
  window.addEventListener('scroll',update,{passive:true}); update();
})();
